import {
  BarChartRounded,
  PieChartRounded,
  TrendingUpRounded,
} from '@mui/icons-material';
import { QuantifyVisualisationType } from 'generated/graphql';

export function getVisualisationTypeIcon(
  visualisationType: QuantifyVisualisationType,
) {
  switch (visualisationType) {
    case QuantifyVisualisationType.Bar:
      return (
        <BarChartRounded fontSize="small" sx={{ transform: 'rotate(90deg)' }} />
      );
    case QuantifyVisualisationType.Trend:
      return <TrendingUpRounded fontSize="small" />;
    case QuantifyVisualisationType.Pie:
      return <PieChartRounded fontSize="small" />;
  }

  return null;
}
